module.exports = __webpack_public_path__ + "img/shape.93af82fd.svg";